import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SideNav from '@/components/ui/sidenav/sidenav';

export default function MainLayout() {
    const location = useLocation();

    // Don't render the SideNav on the login page
    const isLoginPage = location.pathname === '/';

    return (
        <div className="flex h-screen flex-col md:flex-row md:overflow-hidden">
            {!isLoginPage && (
                <div className="w-full flex-none md:w-64">
                    <SideNav />
                </div>
            )}
            <div className="flex-grow p-6 md:overflow-y-auto md:p-12">
                <Outlet />
            </div>
        </div>
    );
}
